import { PaginationHybrid } from "./PaginationHybrid";
import type { PaginationProps } from "./PaginationTypes";

/**
 * Pagination component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or styled() extension).
 *
 * Defined as a self-named component (rather than a bare re-export of
 * PaginationHybrid) so the `react-docgen` props-docs generation in the Publish
 * pipeline has a suitable component definition to analyze.
 */
export const Pagination = (props: PaginationProps) => (
  <PaginationHybrid {...props} />
);

Pagination.displayName = "Pagination";
